define('views/conversations/Podio.Views.Conversations.New',['require','underscore','jquery','translate','lib/jquery/jquery.serializeObject','lib/jquery/jquery.elastic','lib/backbone/Backbone.PodioView','lib/Podio.UI.PeoplePicker','lib/Podio.UI.Embeds','lib/Podio.UI','lib/Podio.Config','jst!conversations/_new','jst!shared/_common_form_embed_actions'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var t = require('translate');
  require('lib/jquery/jquery.serializeObject');
  require('lib/jquery/jquery.elastic');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var PeoplePicker = require('lib/Podio.UI.PeoplePicker');
  var embeds = require('lib/Podio.UI.Embeds');
  var podioUI = require('lib/Podio.UI');
  var podioConfig = require('lib/Podio.Config');

  var jstNew = require('jst!conversations/_new');
  var jstCommonFormEmbedActions = require('jst!shared/_common_form_embed_actions');

  const MAX_CHAR_LIMIT = 1000;

  return PodioView.extend({

    podioEvents: {
      'submit form#new_conversation_v2': 'onFormSubmitted',
      'input #conversation_text_v2'     : 'onInputChange'
    },

    podioPickerOptions: {},

    initialize: function(options) {
      this._super();
      _.bindAll(this, 'render');
      $.extend(this.podioPickerOptions, options.podioPickerOptions || {});
    },

    _initElements: function() {
      this.elmForm = $('form#new_conversation_v2');

      // Participants
      this.podioPickerOptions.initialFocusInInput = !this.options.prePopulate;
      this.elmParticipants = this.elmForm.find('#conversation_participant_list_v2');
      this.peoplePicker = new PeoplePicker(this.elmParticipants, 'conversation', {
        podioPickerOptions: this.podioPickerOptions,
        prePopulate: this.options.prePopulate
      });

      // Subject
      this.elmSubject = this.elmForm.find('#conversation_subject_v2');
      this.elmSubject.val(this.options.subject);

      // Text
      this.elmText = this.elmForm.find('#conversation_text_v2');
      this.elmText.val(this.options.text);
      this.elmText.elastic();

      // Focus
      if (!this.podioPickerOptions.initialFocusInInput) {
        if (!this.options.subject) {
          this.elmSubject.focus();
        } else if (!this.options.text) {
          this.elmText.focus();
        }
      }

      // Buttons
      this.elmSubmitButton = this.elmForm.find('#send_conversation_button_v2');

      // Form embed actions
      this.elmActionBox = this.elmForm.find('.form-embed-actions .action-box');
    },

    onInputChange: function() {
      var text = this.elmText.val();
      var textlength = text.length;
      if (textlength > MAX_CHAR_LIMIT) {
        text = text.slice(0, MAX_CHAR_LIMIT);  // Truncate text to MAX_CHAR_LIMIT characters
        textlength = text.length;
        this.elmText.val(text);  // Update textarea value with truncated text
        this.elmText.addClass('error').focus();
      }
      else {
        this.elmText.removeClass('error');
      }
      
      // Always update the placeholder with the current text length
      this.trigger('composer:changed', text, textlength); 
      $('.modal-char-count').text(textlength + '/' + `${MAX_CHAR_LIMIT}`);
    },


    onFormSubmitted: function(elmTarget, e) {
      if ( this.elmForm.valid() ) {
        podioUI.disableButtonWithLoader(this.elmSubmitButton);

        var values = this.elmForm.serializeObject();

        var embedInfo = embeds.getCurrentEmbedInfo(this.elmActionBox);
        if (embedInfo) {
          values['embed_id'] = embedInfo.embed_id;
          if (embedInfo.selected_file_id) {
            values['embed_file_id'] = embedInfo.selected_file_id;
          }
        }

        values['file_ids'] = this.elm.find('.files-hidden-input').val();

        this.options.eventBus.trigger('conversationForm:submit', values);
      }
    },

    render: function() {
      this.elm.html(this.getTemplate(jstNew, {
        hideProTip: podioConfig.user.properties['conversation_hotkey_dismissed'] || this.options.hideProTip,
        translations: {
          to: t('To #conversations.new'),
          subject: t('Subject #conversations.new'),
          message: t('Message #conversations.new'),
          cancel: t('Cancel #conversations.new'),
          send_message: t('Send message #conversations.new')
        },
        jstCommonFormEmbedActions: jstCommonFormEmbedActions
      }));

      this._initElements();

      if (this.options.popPeopleFinder) {
        this.peoplePicker.showPeopleFinder();
      }

      return this;
    },

    restoreAfterSubmit: function() {
      podioUI.restoreButtonWithLoader(this.elmSubmitButton);
    }

  });

});

